// extracted by mini-css-extract-plugin
module.exports = {"fox_illustration":"style-module--fox_illustration--3MSND","container":"style-module--container--3kyYl","fox":"style-module--fox--zRrkG","leaves":"style-module--leaves--3br-Q"};